import { TabType } from '@entities/Product/module/types/productSchema';

export const sortTabs = (array, indexA, title): TabType[] => {
  const newArray = [...array];
  const indexB = array.findIndex(x => x.title === title);
  if (indexB !== -1) {
    [newArray[indexA], newArray[indexB]] = [newArray[indexB], newArray[indexA]];
  }

  return newArray;
};
